// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import AuditLogView from "./view";

import PendingComponent from "../../../../components/PendingComponent";
import { isMeaningfulGigsOrDemo } from "../../../../utils/auth";
import { authLayoutRoute } from "../../../auth-layout/route";
import { ticketsRoute } from "../../../tickets/route";

export const auditLogRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "roi/audit",
  validateSearch(search: Record<string, unknown>) {
    const schema = z.object({
      page: z.coerce.number().optional(),
      // Single atomic task ID to filter by (e.g., "AT1")
      // Stored as simple string to avoid URL encoding issues like %5B%5D
      atomicTasks: z.string().optional(),
      // Date range for cycle_start filter
      startDate: z.string().optional(),
      endDate: z.string().optional(),
      // Filter mode for task category: "includes" (checked for) or "has_issues" (has errors)
      atomicTaskFilterMode: z
        .enum(["includes", "has_issues"])
        .optional()
        .default("includes"),
    });

    return schema.parse(search);
  },
  beforeLoad() {
    // why: the same gate as the dashboard that links here (routes/roi/route.tsx).
    // Its AutomationTable renders the /roi/audit anchor ungated, so gating the
    // destination narrower dead-ends the demo tenants the dashboard admits.
    if (!isMeaningfulGigsOrDemo()) {
      throw redirect({
        to: ticketsRoute.to,
      });
    }
  },
  loaderDeps({ search }) {
    return search;
  },
  async loader({ deps }) {
    return {
      page: deps.page,
      atomicTasks: deps.atomicTasks,
      startDate: deps.startDate,
      endDate: deps.endDate,
      atomicTaskFilterMode: deps.atomicTaskFilterMode,
    };
  },
  component: AuditLogView,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
